
$(document).ready(() => {

    // FUNCTIONS

    // $('#fullpage').fullpage();

    // new fullpage('#fullpageExample');

    // --------------
    const cap1 = new fullpage('#fullpage-cap1', {
        scrollingSpeed: 700,
        responsiveWidth: 992,
        scrollOverflow: true,
        anchors: ['s1', 's2', 's3', 's4','s5', 's6', 's7', 's8','s9', 's10'],
        scrollBar: true,
    });
    const fullPage1 = new fullpage('#fullpage', {
        scrollingSpeed: 700,
        responsiveWidth: 992,
        scrollOverflow: true,
        scrollBar: true,
    });


    const detectNavegator = () => {
        var is_chrome = !!window.chrome && !is_opera;
        var is_explorer= typeof document !== 'undefined' && !!document.documentMode && !isEdge;
        var is_firefox = typeof window.InstallTrigger !== 'undefined';
        var is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        var is_opera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

        // if (is_safari){
        //     return 'safari';
        // }

        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || is_safari ) {
            return 'safari';
        }
    }


    const buttonFooter = $('#footer__button');
    const footer = $('#footer');
    buttonFooter.click(() => {
        footer.toggleClass('active')
    })

    const buttonOpenSearch = $('#open__search');
    const buttonClosedSearch = $('#close__search');
    const asideSearch = $('#aside__search');

    buttonOpenSearch.click(() => {
        asideSearch.addClass('active')
        document.querySelector('body').classList.add('over-flow-hidden');
    })
    buttonClosedSearch.click(() => {
        asideSearch.removeClass('active');
        document.querySelector('body').classList.remove('over-flow-hidden');
    })

    const buttonOpenNavigation = $('#open_navigation');
    const buttonClosedNavigation = $('#close_navigation');
    const navigation = $('#navigation_menu');
    buttonOpenNavigation.click(() => {
        navigation.addClass('active')
        if(detectNavegator() != 'safari'){
            document.querySelector('body').classList.add('over-flow-hidden');
        }
    })
    buttonClosedNavigation.click(() => {
        navigation.removeClass('active');
        if(detectNavegator() != 'safari'){
            document.querySelector('body').classList.remove('over-flow-hidden');
        }
    })



    // MODAL FUNCTION
    // OPEN ANY MODAL
    const buttonOpenModal = document.querySelectorAll('.openModal')
    buttonOpenModal.forEach( (button) => {
        button.addEventListener('click', (e) => {
            if(e.target.dataset.targetModal){
                const target = e.target.dataset.targetModal;
                const modal = document.getElementById(target)
                modal.classList.add('active');
                document.querySelector('body').classList.add('over-flow-hidden');
            }
        })
    });
    // CLOSE ANY MODAL
    const buttonCloseModal = document.querySelectorAll('.closeModal')
    buttonCloseModal.forEach( (button) => {
        button.addEventListener('click', (e) => {
            const target = e.target
            const modal = target.parentElement.parentElement.parentElement
            modal.classList.remove('active');
            document.querySelector('body').classList.remove('over-flow-hidden');

            $('#video-modal').each(function(){
                this.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
            });

        })
    });

    const buttonOpenTooltip = document.querySelectorAll('.openTooltip')
    buttonOpenTooltip.forEach( (button) => {
        button.addEventListener('click', (e) => {
            console.log('active');
            if(e.target.dataset.targetTooltip){
                const target = e.target.dataset.targetTooltip;
                const tooltip = document.getElementById(target)
                tooltip.classList.add('active')
            }
        })
    });
    // CLOSE ANY MODAL
    const buttonCloseTooltip = document.querySelectorAll('.closeTooltip')
    buttonCloseTooltip.forEach( (button) => {
        button.addEventListener('click', (e) => {
            const target = e.target;
            const tooltip = target.parentElement;
            tooltip.classList.remove('active')
        })
    });


    document.addEventListener('click', e => {
        const modalActive = document.querySelector('.modal.active')
        if(modalActive){
            if(e.target.classList.value == "modal active"){
                e.target.classList.remove('active')
                document.querySelector('body').classList.remove('over-flow-hidden');

                $('#video-modal').each(function(){
                this.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
            });
            }
        }
    });

    document.addEventListener('keyup', (e) => {
        const modalActive = document.querySelector('.modal.active')
        if(e.keyCode == 27){
            modalActive.classList.remove('active')
            document.querySelector('body').classList.remove('over-flow-hidden');

            $('#video-modal').each(function(){
                this.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
            });
        }
    });



    // HOVER A LAS CARDS
    const sectionMain = document.getElementById('section-main');
    const cards = document.querySelectorAll('.card__book img');


    // console.log(window.innerWidth);
    // const rest =  window.innerWidth - sectionMain.clientWidth ;
    // console.log(rest);



    cards.forEach( (card, index) => {
        card.addEventListener('mouseenter', (e)=> {
            const element = e.currentTarget;
            setTimeout( () => {
                cards.forEach( card => {
                    card.parentElement.classList.remove('hover')
                    card.parentElement.style = "";
                });
                const rest = window.innerWidth - sectionMain.clientWidth;
                // console.log(window.innerWidth, sectionMain.clientWidth, card.clientWidth*4, rest);
                if(window.innerWidth > 992){

                    element.parentElement.classList.add('hover');

                    if(window.innerWidth < 1335 && index == 0){
                        carousel.scrollLeft += carousel.offsetWidth;
                        // element.parentElement.style.transform = `scale(1.4) translateX(${rest}px) `
                    }else if(window.innerWidth < 1335 && index == 3){
                        // console.log(rest);
                        // element.parentElement.style.transform = `scale(1.4) translateX(${-rest}px)`
                    }else{

                        // element.parentElement.style.transform = `scale(1.4)`
                    }
                }
                element.parentElement.classList.add('hover');

                $('body').addClass('over-flow-hidden')
            })
        })
    })


    if(sectionMain){
        sectionMain.addEventListener('mouseleave', () => {
            cards.forEach( card => {
                card.parentElement.classList.remove('hover')
                card.parentElement.style = ``
            });
            $('body').removeClass('over-flow-hidden')
        });
    }

    // ACORDEON
    $('.accordion__item').click(function(){
        $(this).find('.accordion__content').slideToggle();
        $(this).find('.accordion__title__container').toggleClass('active')
    })


    const carousel = document.querySelector('.carousel')
    const books = document.querySelector('.card')
    const buttonNext = document.getElementById('button_next')
    const buttonPrev = document.getElementById('button_prev')



    // if(buttonNext && buttonPrev){
    //     buttonNext.addEventListener('click', () => {
    //         carousel.scrollLeft += carousel.offsetWidth;
    //     });
    //     buttonPrev.addEventListener('click', () => {
    //         carousel.scrollLeft -= carousel.offsetWidth;
    //     });
    // }




    // DETECTATNO SCROLL PARA CAMBIAR COLOR DEL HEADER
    window.addEventListener('scroll',() => {

        if(window.innerWidth < 992){

            if(window.pageYOffset > 50){
                document.querySelector('.txt-quote__main.txt-quote__main--mobile.text-primary').style.display = 'none';
                const subtitle = document.querySelector('.txt-quote__subtitle');
                if(subtitle){
                    subtitle.style.display = 'none';
                }
            }else if(window.pageYOffset < 50){
                document.querySelector('.txt-quote__main.txt-quote__main--mobile.text-primary').style = '';
                const subtitle = document.querySelector('.txt-quote__subtitle');
                if(subtitle){
                    subtitle.style.display = 'none';
                }
            }

        }

        const sections = document.querySelectorAll('[data-color]');
        // console.log(sections);
        sections.forEach((element,index) => {
            const resta = element.offsetTop - 40;
            const beforeSection = sections[index];
            // if(index == 0){

            //     console.log(element.clientHeight, element.scrollHeight, element.offsetHeight, element.offsetTop - 40);
            // }
            // if(index == 1){
            //     console.log(element.clientHeight, element.scrollHeight, element.offsetHeight, element.offsetTop - 40);
            // }

            // console.log(beforeSection.offsetTop - 40);
            const suma = element.clientHeight + resta;
            if(window.pageYOffset > resta && window.pageYOffset < suma){
                const color = element.dataset.color;
                // console.log(color);
                // console.log(element)
                if(color == "white"){
                    // document.getElementById('header-second').classList.remove("grey");
                }else if(color == "grey"){
                    // document.getElementById('header-second').classList.remove("white");
                }

                // document.getElementById('header-second').classList.add(color);
            }else{

                // document.getElementById('header-second').classList.remove("grey");
                // document.getElementById('header-second').classList.remove("white");
                // document.getElementById('header-second').classList.add('white');
            }


        })
        // let section1 = document.querySelector('#nutresaBlanco');

        // if(window.pageYOffset > resta){
        //     document.getElementById('header-second').classList.add("grey");
        //     document.getElementById('header-second').classList.remove("white");
        // }else{
        //     document.getElementById('header-second').classList.remove("grey");
        //     document.getElementById('header-second').classList.add("white");
        // }


    })


// Background scroll on header secondary


window.onscroll = function () {
    let header= document.getElementById('header-second'),
        y = window.scrollY;

    let elmnt = header.offsetHeight

    if (y >= elmnt ) {
        header.classList.add('active-overflow')
    } else {
        header.classList.remove('active-overflow')
        header.style.transition = 'all ease .5s';
    }
};


// MENU


$('.item__link').click(function(e){
    // console.log('click')
    $(this).parent().next('.sub-items').slideToggle()
    $(this).parent().parent().siblings().find('.sub-items').slideUp()
})

$('.sub-item__link').click(function(e){
    // console.log('click sub item')
    $(this).next('.sub-items').slideToggle()
})

// $('.items').on('click', '.item', function(e) {
//     e.preventDefault();
//     let item = $(this);
//     let itemUl = item.find('.sub-items')
//     let parents = item.siblings().find('.sub-items')
//     itemUl.slideToggle();
//     parents.slideUp();
// })

});



